export enum ErrorStatus {
    UNEXPECTED_ERROR,
    NOT_FOUNT,
    INPUT_IS_NULL,
    INPUT_INVALID,
    INTERNAL_ERROR,
    COMMIT_FAIL,
    NO_ROWS_AFFECTED,
    UNAUTHORIZED,
    ALREADY_EXIST,
    AlREADY_INUSE,
    //User Error Messages 
    EMAIL_ALREADY_EXIST,
    MOBILE_ALREADY_EXIST,
    Code_ALREADY_EXIST,
    USER_ALREADY_EXIST,
    Branch_Assigned_Staff,

    //Transporter Errors
    PLATE_ALREADY_EXIST,
    TRANSPORTER_CODE_EXIST,
    ChassisNumber_EXIST,
    LicenseNumber_EXIST,

    //Device Error
    DEVICE_CODE_EXIST,
    TRANSPORTER_ALREADY_ASSIGNED,
    DEVICE_SIM_EXIST,

    //Forgot Password
    EMAIL_NOT_FOUND,

    //Branch
    INVALID_PARENT_ID,
    BRANCH_CODE_EXIST,
    BRANCH_HAS_CHILDREN,
    Branch_Assigned_Transporter,

    //Customer
    Customer_Mobile_EXIST,

    //Student
    STUDENT_RFID_EXIST,


    //Organization
    Organization_HAS_CHILDREN,
    Organization_HAS_Staff,

    // Subscriber Domain Exists
    SUBSCRIBER_Domain_EXIST,

    //Staff
    Staff_Assigned_Transporter,
    StaffAllocationConflict,

    //vechile
    VechileAllocationConflict,
    // Date
    INVALID_DATE,

    // Reporting
    TOO_MANY,
    INVALID_COMBINATION,
    FILTER_NOT_GROUPED,
    ORDER_ISNOT_PENDING

}


// WEBPACK FOOTER //
// D:/TFS/Softec.FMS-Core-Live/Source/Frontend/Web/Softec.FMS.Client.WebView-ng4/app/shared/dataModels/error-status.ts